import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Select,
  Slide,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";
import axios from "axios";
import Button from "../../../components/CustomButtons/Button";
import SaveButton from "../../../components/CustomInput/SaveButton";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { withStyles } from "tss-react/mui";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Move extends React.Component {
  state = {
    saving: false,
    hasError: false,
    vestigingen: [],
    selectedVestiging: "",
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && this.state.vestigingen.length === 0) {
      this.loadVestigingen();
    }
  }

  move = () => {
    this.setState({ saving: true });

    const data = {
      vestiging_id: this.state.selectedVestiging,
      tafel_ids: this.props.selectedTafelIds,
    };

    axios.post("core/tafels/move", data).then((response) => {
      if (response.data.data.success) {
        this.setState({
          saving: false,
          hasError: false,
        });

        const message = response.data.data.count + " " + response.data.data.message;
        toast.success(message);
        this.props.handleSuccess();
      } else {
        this.setState({
          saving: false,
          hasError: true,
        });
        toast.error(response.data.data.message);
      }
    });
  };

  disableSave = () => {
    return this.state.selectedVestiging === "";
  };

  loadVestigingen = () => {
    axios
      .get(
        "core/vestigingen?per_page=5000&fields=id as value, systeemNaam as label&sort_field=systeemNaam&sort_dir=asc"
      )
      .then((response) => {
        let vestigingen = response.data.data.data;
        this.setState({ vestigingen: vestigingen });
      });
  };

  handleType = (name) => (event) => {
    let newState = { ...this.state };
    newState[name] = event.target.value;
    this.setState(newState);
  };

  render() {
    const { classes } = this.props;
    let vestigingenItems = convertObjectToSelectOptions(this.state.vestigingen, classes);

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Verplaats tafels"} tKey={"tafels.modal.move.titel"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"Vestiging"} tKey={"tafels.modal.move.form.selectedVestiging"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <Select
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  inputProps={{
                    name: "simpleSelect",
                    id: "simple-select",
                    style: { paddingTop: "32px" },
                  }}
                  onChange={this.handleType("selectedVestiging")}
                  value={this.state.selectedVestiging}
                >
                  {vestigingenItems}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={
              getTranslation("tafels.modal.move.form.button.verplaats", "Verplaats") +
              " (" +
              this.props.selectedTafelIds.length +
              ")"
            }
            disabled={this.disableSave()}
            hasError={this.state.hasError}
            onClick={this.move}
            saving={this.state.saving}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(Move, notificationsStyle);
